import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import './Layout3D.css';

const Layout3D = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isOnGameSelect = location.pathname === '/';

  const handleReturnToGames = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <div className="casino-3d">
      <header className="casino-3d-header">
        <div className="casino-3d-header-left">
          {!isOnGameSelect && (
            <button className="casino-3d-btn casino-3d-btn-back" onClick={handleReturnToGames}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <polyline points="15,18 9,12 15,6"/>
              </svg>
              {t('games_label')}
            </button>
          )}
        </div>

        <div className="casino-3d-header-center">
        </div>

        <div className="casino-3d-header-right">
        </div>
      </header>

      <main className="casino-3d-content">
        {children}
      </main>
    </div>
  );
};

export default memo(Layout3D);
